/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum OtherMonitors {
  ETCO2 = 'ETCO2 - Et CO2',

  CVP = 'CVP - Centra Venous Pressure',

  CO = 'CO- Cardiac Output Monitoring',

  PCWP = 'PCWP - Pulmonary Capillary Wedge Pressure',

  SSEP = 'SSEP - Somatosensory Evoked Potentials',
}
